//
//
//
//
//
//

import { UserLog } from '@/_base/log'
export default {
    methods: {
        goDetail () {
            UserLog.click_discuss_group(this.building_id)
            this.$sendCtmEvtLog('楼盘详情-功能模块-加群banner点击', {building_id: this.building_id})
            wx.navigateTo({
                url: `/building/discuess_group/main?link=${this.add_group_url}`
            })
        }
    },
    props: {
        building_id: {
            type: String
        },
        add_group_url: {
            type: String
        }
    }
}
